import React from 'react';

import SvgIcon from './SvgIcon';

const Logo = props => (
    <SvgIcon {...props}>
        <svg viewBox="0 0 192 192">
            <circle cx="95" cy="72.71" r="53.38" fill="#fff" />
            <path
                d="M105.58 40.15a89.63 89.63 0 0 1-5.69-18.9 51.73 51.73 0 0 0-39 12.67 90.43 90.43 0 0 1 6.43 18.67 90.61 90.61 0 0 0 38.27-12.44"
                fill="#0081a5"
            />
            <path
                d="M67.31 52.59a90 90 0 0 1-19.73-.43c-.64 1.47-1.23 3-1.74 4.54a51.41 51.41 0 0 0 1.74 36.47 90.53 90.53 0 0 1 19.74-.34 90.49 90.49 0 0 0 0-40.24"
                fill="#f15c22"
            />
            <path
                d="M60.88 33.92a51.25 51.25 0 0 0-13.3 18.24 90 90 0 0 0 19.73.43 90.43 90.43 0 0 0-6.43-18.67"
                fill="#483829"
            />
            <path
                d="M105.59 105.25a90.45 90.45 0 0 0-38.27-12.42 89.75 89.75 0 0 1-6.51 18.64 51.59 51.59 0 0 0 39 12.71 91.08 91.08 0 0 1 5.78-18.93"
                fill="#c4c4c4"
            />
            <path
                d="M67.32 92.83a90.54 90.54 0 0 0-19.74.34 51.67 51.67 0 0 0 13.23 18.3 89.54 89.54 0 0 0 6.51-18.64"
                fill="#d6450d"
            />
            <path
                d="M105.59 105.25a89.15 89.15 0 0 1 15.69 11.93 51.49 51.49 0 0 0 22.9-28.47c.5-1.56.91-3.11 1.26-4.68a90.21 90.21 0 0 1-16.2-11.34 90.57 90.57 0 0 0-23.65 32.56"
                fill="#fdb813"
            />
            <path
                d="M99.81 124.18a51.92 51.92 0 0 0 21.47-7 89.15 89.15 0 0 0-15.69-11.93 91.08 91.08 0 0 0-5.78 18.93"
                fill="#e39400"
            />
            <path
                d="M129.24 72.69a89.61 89.61 0 0 1 16.19-11.23 51.71 51.71 0 0 0-24.07-33.21 91.07 91.07 0 0 1-15.78 11.9 90.31 90.31 0 0 0 23.66 32.54"
                fill="#78a22f"
            />
            <path
                d="M121.36 28.25a50.47 50.47 0 0 0-21.47-7 89.63 89.63 0 0 0 5.69 18.9 91.07 91.07 0 0 0 15.78-11.9"
                fill="#00703c"
            />
            <path
                d="M129.24 72.69A90.21 90.21 0 0 0 145.44 84a51.31 51.31 0 0 0 0-22.57 89.61 89.61 0 0 0-16.19 11.23"
                fill="#695c21"
            />
        </svg>
    </SvgIcon>
);

Logo.displayName = 'LogoIcon';

export default Logo;
